import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { toast } from 'react-toastify';
import './documentstab.css';

import { GetSharedCaseFilesAsync } from '../../../services/fileServices/FileService';
import tableeyeopenicon from '../../../assets/images/tableeyeopenicon.svg';
import { useAuth } from '../../../firebase/AuthProvider';
import { SheredCaseFileRes } from '../../../interfaces/file/file';
import Loader from '../loader/Loader';
import { PaginationDto } from '../../../interfaces/Employee/Employee';
import Pagination from '../../ui/Pagination/Pagination';
import { Table } from 'react-bootstrap';

const Documentstab: React.FC = () => {
    const { currentUser } = useAuth();
    const { userId: viewedUserId } = useParams();
    const navigate = useNavigate();
    const [pagination, setPagination] = useState<PaginationDto>({ pageNumber: 1, pageSize: 10 });
    const [sharedFiles, setSharedFiles] = useState<SheredCaseFileRes[]>([]);
    const [sharedFileCount, setSharedFileCount] = useState<number>();
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        let isMounted = true;
        if (!currentUser) return;
        currentUser.getIdToken().then((token) => {
            if (isMounted) {
                GetSharedCaseFiles(token);
            }
        });
        return () => {
            isMounted = false;
        };
    }, [pagination])

    const GetSharedCaseFiles = async (token: string) => {
        if (!token || !viewedUserId) return;

        try {
            setLoading(true);
            const res = await GetSharedCaseFilesAsync(token, viewedUserId, pagination.pageNumber, pagination.pageSize);

            if (res.success) {
                setSharedFiles(res.data.sharedFileDto);
                setSharedFileCount(res.data.count);
            } else {
                toast.error(res.message);
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };


    const onPageChange = (pageNum: number) => {
        setPagination((prev) => ({
            ...prev,
            pageNumber: pageNum
        }))
    }

    const resetPageSize = (pageNumber: number, pageSize: number) => {
        setPagination({
            pageNumber: pageNumber,
            pageSize: pageSize
        })
    }

    return (
        <>
            {loading && <Loader />}
            <div className='common_content_inner mby_t_24'>
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>File Name</th>
                            <th>Uploaded By</th>
                            <th>Uploaded Date</th>
                            <th className='action_th'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sharedFiles.map((file, index) => (
                            <tr key={index}
                                className="border-t border-gray-200 dark:border-gray-700 text-sm hover:bg-gray-50 dark:hover:bg-gray-800"
                                onClick={() => {
                                    navigate(`/view/user/file/${file.fileId}`);
                                }}
                            >
                                <td className="file-name">{file.fileName}</td>
                                <td className="user-name">
                                    {file.uploadedByUserName}
                                </td>
                                <td className="file-upload-date">
                                    {moment
                                        .utc(file.uploadedOn)
                                        .local()
                                        .format("DD/MM/YYYY")}
                                </td>
                                <td>
                                    <div className='action_btn'>
                                        <span><img src={tableeyeopenicon} alt="tableeyeopenicon" /></span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {(sharedFileCount && sharedFileCount > 0) ? (
                    <Pagination
                        currentPage={pagination.pageNumber}
                        totalPages={Math.ceil(sharedFileCount / pagination.pageSize)}
                        onPageChange={onPageChange}
                        pageSize={pagination.pageSize}
                        resetPageSize={resetPageSize}
                    />
                ) : <></>}
            </div>
        </>
    );
};

export default Documentstab;